export const loadTodoistSourcePill = () => import('../components/TodoistSourcePill')
export const loadEmailSourcePill = () => import('../components/EmailSourcePill')
export const loadCommitmentReviewPill = () => import('../components/CommitmentReviewPill')
export const loadCommitmentAddPill = () => import('../components/CommitmentAddPill')
export const loadEventTicketPill = () => import('../components/EventTicketPill')
export const loadTweetPreviewCard = () => import('../components/TweetPreviewCard')

const COMMITMENTS_CHAT_ID = 'pwa-auto-commitments'
const TODOIST_TASK_SOURCE_KINDS = new Set([
  'todoist',
  'todoist_task',
])
const TODOIST_SOURCE_PILL_KINDS = new Set([
  ...TODOIST_TASK_SOURCE_KINDS,
  'x_bookmark',
  'health_check',
  'freelancer_event',
  'youtube_video',
  'architecture_deepen',
])
const TWEET_PREVIEW_SOURCE_KINDS = new Set([
  ...TODOIST_TASK_SOURCE_KINDS,
  'x_bookmark',
])
const COMMITMENT_REVIEW_PILL_KINDS = new Set([
  'commitment_group',
  'commitment_followup',
  'commitment_review',
])

export function preloadThreadViewComponents(): void {
  // MessageList and TopicTabs are deliberately eager in ChatPage. Keeping
  // this stable hook lets existing hover/touch callers express intent while
  // guaranteeing the offline notification thread shell is already in the
  // app bundle and can never suspend on a missing lazy chunk.
}

export function chatUsesCommitmentAddPill(chatId: string | null | undefined): boolean {
  return chatId === COMMITMENTS_CHAT_ID
}

export function topicUsesTodoistSourcePill(sourceKind: string | null | undefined): boolean {
  return !!sourceKind && TODOIST_SOURCE_PILL_KINDS.has(sourceKind)
}

export function topicUsesEmailSourcePill(sourceKind: string | null | undefined): boolean {
  return sourceKind === 'email_inbound'
}

export function topicUsesCommitmentReviewPill(sourceKind: string | null | undefined): boolean {
  return !!sourceKind && COMMITMENT_REVIEW_PILL_KINDS.has(sourceKind)
}

export function topicUsesEventTicketPill(sourceKind: string | null | undefined): boolean {
  return sourceKind === 'event_ticket'
}

export function topicUsesTweetPreviewCard(sourceKind: string | null | undefined): boolean {
  return !!sourceKind && TWEET_PREVIEW_SOURCE_KINDS.has(sourceKind)
}

export function preloadThreadSourceComponents({
  chatId,
  sourceKind,
  tweetPreviewOpen = false,
}: {
  chatId?: string | null
  sourceKind?: string | null
  tweetPreviewOpen?: boolean
}): void {
  if (chatUsesCommitmentAddPill(chatId)) void loadCommitmentAddPill()
  if (topicUsesTodoistSourcePill(sourceKind)) void loadTodoistSourcePill()
  if (topicUsesEmailSourcePill(sourceKind)) void loadEmailSourcePill()
  if (topicUsesCommitmentReviewPill(sourceKind)) void loadCommitmentReviewPill()
  if (topicUsesEventTicketPill(sourceKind)) void loadEventTicketPill()
  if (tweetPreviewOpen && topicUsesTweetPreviewCard(sourceKind)) void loadTweetPreviewCard()
}

export function preloadThreadViewComponentsForTopic({
  chatId,
  sourceKind,
  tweetPreviewOpen = false,
}: {
  chatId?: string | null
  sourceKind?: string | null
  tweetPreviewOpen?: boolean
} = {}): void {
  preloadThreadViewComponents()
  preloadThreadSourceComponents({ chatId, sourceKind, tweetPreviewOpen })
}
